import {
  FETCH_SUBSCRIPTION_DATA_REQUEST,
  FETCH_SUBSCRIPTION_DATA_SUCCESS,
  FETCH_SUBSCRIPTION_DATA_FAILURE,
  FETCH_SUBSCRIPTION_PLANS_REQUEST,
  FETCH_SUBSCRIPTION_PLANS_SUCCESS,
  FETCH_SUBSCRIPTION_PLANS_FAILURE,
  SELECT_SUBSCRIPTION_PLAN,
  CREATE_ORDER_REQUEST,
  CREATE_ORDER_SUCCESS,
  CREATE_ORDER_FAILURE,
  CLEAR_ORDER_DATA,
  VERIFY_PAYMENT_REQUEST,
  VERIFY_PAYMENT_SUCCESS,
  VERIFY_PAYMENT_FAILURE,
  OPEN_RAZORPAY_CHECKOUT,
  RAZORPAY_CHECKOUT_SUCCESS,
  RAZORPAY_CHECKOUT_FAILURE,
  CLOSE_SUCCESS_MODAL,
  CLEAR_SUBSCRIPTION_DATA,
  FETCH_BLOCKED_USERS_LIST_REQUEST,
  FETCH_BLOCKED_USERS_LIST_SUCCESS,
  FETCH_BLOCKED_USERS_LIST_FAILURE,
} from './constants';

const initialState = {
  loading: false,
  subscriptionData: {},
  subscriptionPlans: [],
  selectedPlan: null,
  isSubscribed: false,
  subscriptionEndDate: null,
  error: null,
  // Payment flow states
  creatingOrder: false,
  orderData: null,
  verifyingPayment: false,
  paymentVerified: false,
  razorpayCheckoutOpen: false,
  paymentResponse: null,
  showSuccessModal: false,
  // Blocked users list states
  blockedUsersList: [],
  blockedUsersListLoading: false,
  blockedUsersListError: null,
};

const SubscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SUBSCRIPTION_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_SUBSCRIPTION_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        subscriptionData: action.payload,
        subscriptionPlans: action.payload.subscription_plans || [],
        isSubscribed: action.payload.is_subscribed || false,
        subscriptionEndDate: action.payload.subscription_end_date || null,
        error: null,
      };

    case FETCH_SUBSCRIPTION_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case FETCH_SUBSCRIPTION_PLANS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_SUBSCRIPTION_PLANS_SUCCESS:
      return {
        ...state,
        loading: false,
        subscriptionPlans: action.payload || [],
        error: null,
      };

    case FETCH_SUBSCRIPTION_PLANS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SELECT_SUBSCRIPTION_PLAN:
      return {
        ...state,
        selectedPlan: action.payload,
      };


    // Create Order Cases
    case CREATE_ORDER_REQUEST:
      return {
        ...state,
        creatingOrder: true,
        error: null,
      };

    case CREATE_ORDER_SUCCESS:
      return {
        ...state,
        creatingOrder: false,
        orderData: action.payload,
        error: null,
      };

    case CREATE_ORDER_FAILURE:
      return {
        ...state,
        creatingOrder: false,
        error: action.payload,
      };

    case CLEAR_ORDER_DATA:
      return {
        ...state,
        orderData: null,
        creatingOrder: false,
      };

    // Verify Payment Cases
    case VERIFY_PAYMENT_REQUEST:
      return {
        ...state,
        verifyingPayment: true,
        error: null,
      };

    case VERIFY_PAYMENT_SUCCESS:
      return {
        ...state,
        verifyingPayment: false,
        paymentVerified: true,
        showSuccessModal: true,
        error: null,
      };

    case VERIFY_PAYMENT_FAILURE:
      return {
        ...state,
        verifyingPayment: false,
        paymentVerified: false,
        error: action.payload,
      };

    // Razorpay Checkout Cases
    case OPEN_RAZORPAY_CHECKOUT:
      return {
        ...state,
        razorpayCheckoutOpen: true,
        error: null,
      };

    case RAZORPAY_CHECKOUT_SUCCESS:
      return {
        ...state,
        razorpayCheckoutOpen: false,
        paymentResponse: action.payload,
        error: null,
      };

    case RAZORPAY_CHECKOUT_FAILURE:
      return {
        ...state,
        razorpayCheckoutOpen: false,
        error: action.payload,
      };

    case CLOSE_SUCCESS_MODAL:
      return {
        ...state,
        showSuccessModal: false,
      };
    case CLEAR_SUBSCRIPTION_DATA:
      return {
        ...initialState,
      };

    // Blocked Users List Cases
    case FETCH_BLOCKED_USERS_LIST_REQUEST:
      return {
        ...state,
        blockedUsersListLoading: true,
        blockedUsersListError: null,
      };

    case FETCH_BLOCKED_USERS_LIST_SUCCESS:
      return {
        ...state,
        blockedUsersListLoading: false,
        blockedUsersList: action.payload || [],
        blockedUsersListError: null,
      };

    case FETCH_BLOCKED_USERS_LIST_FAILURE:
      return {
        ...state,
        blockedUsersListLoading: false,
        blockedUsersListError: action.payload,
      };

    default:
      return state;
  }
};

export default SubscriptionReducer;

